import { addDays } from 'date-fns'

export default {
  name: 'project_event_end_date',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  default_value: 'default_values.project.event_end_date',
  static_options: {
    open_date: addDays(new Date(), 1),
    show_time: 'project_display_settings.event.show_time'
  },
  static_mandatory: [
    'minDate:procedure.default_values.project.event_start_date',
    'minDate:procedure_execution.actions_data.project.event_start_date'
  ]
}